import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { ConfigService } from '../services/config.service';

@Injectable()
export class PatentSearchGuard implements CanActivate {

  constructor(private configService: ConfigService) {
  }

  public canActivate(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      // Making sure we are also loading the required data together with the user
      const dataFetch: Promise<any>[] = [];
      dataFetch.push(this.configService.retrieveCountrySearchCodes());

      // When all the data finishes loading async
      Promise.all(dataFetch)
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          console.error('Failed to load onboarding data.');
          reject(false);
        });
    });
  }
}
